import styled from 'styled-components';

import { CommonAction, designColor, recipesCommonAction, styledMedia, styledTypography } from '@pkg/primitives';

interface FlexGroupProps {
    $alignEnd?: boolean;
}

export const StyledFiltersRow = styled.div`
    display: flex;
    gap: 20px;
    flex-direction: column;
`;

export const FiltersRowWrapper = styled.div`
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 20px;
    width: 100%;
    justify-content: space-between;

    @media (max-width: 768px) {
        flex-direction: column;
        justify-content: center;
        gap: 20px;
    }
`;

export const FlexGroup = styled.div<FlexGroupProps>`
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 20px;
    flex-shrink: 0;
    margin-left: ${({ $alignEnd }) => ($alignEnd ? 'auto' : undefined)};

    @media (max-width: 768px) {
        gap: 10px;
        //margin: auto;
    }
`;

export const SearchWrapper = styled.div`
    flex: 1 1 auto;

    @media (max-width: 768px) {
        width: 100%;
    }
`;

export const FilterAction = styled(CommonAction)`
    ${recipesCommonAction.basic};
    gap: 8px;
    padding-left: 16px;
    padding-right: 16px;
    height: 40px;
    background-color: rgb(255, 255, 255, 0.1);

    &:hover:not(:active) {
        background-color: rgba(255, 255, 255, 0.16);
    }

    &[aria-pressed] {
        background-color: ${designColor.brandPurple};

        &:hover:not(:active) {
            background-color: ${designColor.brandPurpleDark};
        }
    }
`;

export const FilterActionLabel = styled.span`
    ${styledTypography.allianceBase};
    ${styledTypography.textBoxTrim};
    display: block;
    font-size: 14px;
    font-weight: 600;
    letter-spacing: -0.02em;
`;

export const FilterActionIconWrapper = styled.span`
    ${styledMedia.iconWrapper};
    width: 16px;
    height: 16px;
`;
